import { CHART_COLORS } from "app/constants/ChartColors";

export const KEYWORDS_REPORT_POSITION_FILTER_PREFERENCES_KEY = "KeywordsReportPositionFilter";
export const DEFAULT_POSITION_SORTING = "volume";
export const DEFAULT_CLICKS_SORTING = "volume";
export const UPDATE_SETTINGS_SUFFIX = "updateSettings";
export const UPDATE_KEYWORDS_SUFFIX = "updateKeywords";
export const TABLE_SELECTION_PROPERTY = "key";
export const CLICKS_METRIC_DECIMAL_ROUND = 1;
export const CLICKS_CHANGE_DECIMAL_ROUND = 0;
export const POSITIONS_DAILY_DECIMAL_ROUND = 0;
export const POSITIONS_WEEKLY_MONTHLY_DECIMAL_ROUND = 1;
export const UNDEFINED_SIGN = "-";
export const sitesColors = CHART_COLORS.compareMainColors;
export const Keywords_Report_Table_State_Key = "KeywordsReportKeywordsTable";
export const Keywords_Report_Table_Remove_Keywords_Toast_Key =
    "seo.keywordsCampaign.wizard.addingKeywordsStep.topBar.removeKeywordsModal.toast";
export const Update_Tags_Failed_Toast_Key = "seo.keywordsReport.table.removeTags.failed.toast";
export const Update_Tags_Success_Toast_Key = "seo.keywordsReport.table.changeTags.success.toast";
export const FIRST_DAY_COLUMN_PREFIX = "firstDay";
export const LAST_DAY_COLUMN_PREFIX = "lastDay";
export const CHANGE_DAY_COLUMN_PREFIX = "change";

export enum EColumnsFields {
    LAST_UPDATED = "lastUpdatedFormatted",
    KEYWORD = "keyword",
    TAGS = "tags",
    GEO_LOCATION = "geoLocation",
    INTENT = "intent",
    CPC = "cpc",
    DIFFICULTY = "difficulty",
    SERP_FEATURES = "serpFeatures",
    TARGET_URL = "targetUrl",
    NUMBER_OF_URLS = "numberOfUrls",
    POSITION_TREND = "positionTrend",
    VOLUME = "volume",
}

export const COLUMN_PICKER_MAX_HEIGHT = 448;
export const KEYWORDS_REPORT_SINGLE_MODE_TABLE_COLUMNS_PREFERENCES_KEY = "keywordsReportTableColumnsSingleMode";
export const KEYWORDS_REPORT_COMPARE_MODE_TABLE_COLUMNS_PREFERENCES_KEY = "keywordsReportTableColumnsCompareMode";
